import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { globalData } from 'tracking/dataCollectors'

import isBrowser from 'utils/isBrowser'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      event: 'view', // trigger GTM tags
      eventType: 'View', // Begin with uppercase. Type of action for pulse.
      pageType: 'frontpage', // Blocket application
      objectType: 'Frontpage', // Begin with uppercase
      domain: 'content', // Technical domain. Ex. Adout
      subDomain: 'index', // Technical sub domain. Ex. list.
      origin: { id: 'front_page, type: Frontpage, url: /' },
      objectId: 'front_page',
      objectName: 'Frontpage',
    },
    ...localData,
  })

/*
 * Event listeners *
 */

export const frontPageView = {
  validators: validators.redux(
    '@@router/LOCATION_CHANGE',
    (action) => action.payload.location.pathname === '/' && isBrowser(),
  ),
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}))],
}
